import React from 'react';
import { useClearRefinements, useInstantSearch } from 'react-instantsearch';

const CustomClearRefinements = (props) => {
    const { canRefine, refine } = useClearRefinements(props);
    const { results } = useInstantSearch();

    return (
        (canRefine && results.nbHits !== 0) ? (
            <div className="w-full group">
                <button
                    disabled={!canRefine}
                    onClick={refine}
                    className={`${props.classNames.button}`}
                >
                    {props.translations.resetButtonText}
                </button>
            </div>
        ) : null
    );
};

export {CustomClearRefinements};

